import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import PlaceIcon from '@mui/icons-material/Place';
import TvIcon from '@mui/icons-material/Tv';

export interface AppDataItem {
    available: boolean;
    badge?: string;
    comingSoonText?: string;
    description: string;
    icon: React.ReactElement;
    name: string;
    type?: string;
    url: string;
}

export const AppArray: AppDataItem[] = [
    {
        available: true,
        badge: 'GetItFromMicrosoft.png',
        comingSoonText: 'Coming soon to the Microsoft Store',
        description: 'Download from the Microsoft Store for Windows 10 & 11',
        icon: <MicrosoftIcon sx={{ height: 'auto', width: 30 }} />,
        name: 'Windows',
        url: 'https://apps.microsoft.com/detail/xpfffdsx8h3mr1?hl=fi-fi&gl=FI&ocid=pdpshare',
    },
    {
        available: true,
        badge: 'GetItOnGooglePlay_Badge_Web_color_English.png',
        description: 'Get it on Google Play for Android devices',
        icon: <AndroidIcon sx={{ height: 'auto', width: 30 }} />,
        name: 'Android',
        url: 'https://play.google.com/store/apps/details?id=com.missing.link.renki',
    },
    {
        available: true,
        badge: 'Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg',
        description: 'Download on the App Store for iPhone and iPad',
        icon: <AppleIcon sx={{ height: 'auto', width: 30 }} />,
        name: 'iOS',
        url: 'https://apps.apple.com/fi/app/renki/id6467124927',
    },
    {
        available: false,
        badge: 'ms-store-badge.png',
        comingSoonText: '',
        description: 'Download from the Google Play Store for Smart TVs',
        icon: <TvIcon sx={{ height: 'auto', width: 30 }} />,
        name: 'Renki Infoscreen',
        type: 'tv',
        url: '',
    },
];

export interface NavItemsProps {
    icon: React.JSX.Element;
    label: string;
    to: string;
    type?: string;
}

export const NavItems: NavItemsProps[] = [
    { icon: <PlaceIcon color="mlBlue" />, label: 'Places', to: '/' },
    { icon: <DevicesOtherIcon color="primary" />, label: 'Devices', to: '/device' },
];
